export default {
  SET_APPLICATION: 'setApplication',
  SET_LOCATION: 'setLocation',
  SET_ROL: 'setRol',
  SET_RESULT: 'setResult',
  SET_MESSAGE_ITEM_COLLAPSE: 'setMessageItemCollapse',
  SET_CURRENT_FILTER: 'setCurrentFilter',
  SET_FILTER: 'setFilter',
};
